import { isMockServices } from 'src/utils';
import mock from 'src/services/utils/mock';
import { MutationFunction } from '@tanstack/react-query';
import { getCompatibleAuthTokenHttp } from '../utils/enhancedAuthTokenHttp';

export interface CreateNotificationTemplateRequest {
  name: string;
  notificationType: string;
  channel: string;
  subjectTemplate: string;
  htmlBodyTemplate: string;
  textBodyTemplate: string;
  variables: Record<string, unknown>;
  isActive?: boolean;
}

export interface CreateNotificationTemplateResponse {
  message: string;
  data: {
    id: string;
    name: string;
    notificationType: string;
    channel: string;
    version: number;
    isActive: boolean;
  };
}

const createNotificationTemplate: MutationFunction<
  CreateNotificationTemplateResponse,
  CreateNotificationTemplateRequest
> = async (args) => {
  if (isMockServices()) {
    return await mock({
      message: 'Notification template created successfully',
      data: {
        id: 'mock-id',
        name: args.name,
        notificationType: args.notificationType,
        channel: args.channel,
        version: 1,
        isActive: args.isActive ?? true,
      },
    });
  }

  const authTokenHttp = await getCompatibleAuthTokenHttp();

  const response = await authTokenHttp<CreateNotificationTemplateResponse>(
    `/notification-templates`,
    {
      method: 'POST',
      body: args,
    },
  );

  if (response.data) return response.data;

  throw new Error('Failed to create notification template');
};

export default createNotificationTemplate;
